import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { users } from 'services/supabase';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

const ReportViewerPage: React.FC = () => {
  const { level, id } = useParams<{ level: 'country' | 'state' | 'lga'; id: string }>();
  const { user } = useAuth();

  const [hasAccess, setHasAccess] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (user && level && id) {
      const checkAccess = async () => {
        setIsLoading(true);
        const { data, error } = await users.checkReportAccess(user.id, level, id);
        if (error) {
          console.error('Error checking report access:', error);
          setHasAccess(false);
        } else {
          setHasAccess(data as boolean);
        }
        setIsLoading(false);
      };
      checkAccess();
    } else if (!user) {
      setIsLoading(false);
      setHasAccess(false);
    }
  }, [user, level, id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="text-center p-8 bg-yellow-50 rounded-lg">
        <ShieldExclamationIcon className="w-16 h-16 mx-auto text-yellow-500" />
        <h2 className="mt-4 text-2xl font-bold text-gray-800">Access Denied</h2>
        <p className="mt-2 text-gray-600">
          You do not have an active subscription for this area.
        </p>
        <Link
          to="/subscription"
          className="mt-6 inline-block bg-primary-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-primary-700 transition-colors"
        >
          View Subscription Options
        </Link>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Security Assessment Report</h1>
      <div className="bg-gray-100 p-4 rounded-lg">
        <p>Report for: <strong>{level?.toUpperCase()}</strong></p>
        <p>ID: <strong>{id}</strong></p>
        <p className="mt-4 text-blue-600">PDF viewer coming soon...</p>
        {/* PDF viewer will be implemented here */}
      </div>
    </div>
  );
};

export default ReportViewerPage;
